// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-containers-Profile-Emails-styles--mail--_DTu1 {
  color: inherit !important;
}

.src-containers-Profile-Emails-styles--twoFactorAuthn--oL0VY {
  padding-top: 0;
}

.src-containers-Profile-Emails-styles--twoFactorAuthn--oL0VY::before {
  height: 0 !important;
}

.src-containers-Profile-Emails-styles--twoFactorAuthnContent--uwNUW {
  align-items: flex-start;
}

.src-containers-Profile-Emails-styles--twoFactorAuthnContent--uwNUW h5 {
  justify-content: flex-start;
  flex-wrap: wrap;
}

.src-containers-Profile-Emails-styles--twoFactorAuthnContent--uwNUW h5 .src-containers-Profile-Emails-styles--additional--A48R4 {
  margin-top: 5px;
}

@media screen and (max-width: 767.98px) {

.src-containers-Profile-Emails-styles--twoFactorAuthnContent--uwNUW h5 .src-containers-Profile-Emails-styles--additional--A48R4 {
    width: 100%;
}
  }

.src-containers-Profile-Emails-styles--tooltip--p4Acb {
  margin-left: 5px;
}

@media screen and (max-width: 767.98px) {

.src-containers-Profile-Emails-styles--tooltip--p4Acb {
    display: none !important;
}
  }

.src-containers-Profile-Emails-styles--tooltip--p4Acb .src-containers-Profile-Emails-styles--tooltipContent--tQrXm {
  width: 280px;
  text-align: center;
}

.src-containers-Profile-Emails-styles--sberIcon--F4yaH {
  width: 15px !important;
  height: 15px !important;
}

.src-containers-Profile-Emails-styles--row--W8wVS {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/containers/Profile/Emails/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;AAKjB;;AAHE;;AAHF;IAII,WAAW;AAEf;EADE;;AAGF;EACE,gBAAgB;AAKlB;;AAHE;;AAHF;IAII,wBAAwB;AAE5B;EADE;;AAGF;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.mail {\n  color: inherit !important;\n}\n\n.twoFactorAuthn {\n  padding-top: 0;\n}\n\n.twoFactorAuthn::before {\n  height: 0 !important;\n}\n\n.twoFactorAuthnContent {\n  align-items: flex-start;\n}\n\n.twoFactorAuthnContent h5 {\n  justify-content: flex-start;\n  flex-wrap: wrap;\n}\n\n.twoFactorAuthnContent h5 .additional {\n  margin-top: 5px;\n\n  @media (--mobile) {\n    width: 100%;\n  }\n}\n\n.tooltip {\n  margin-left: 5px;\n\n  @media (--mobile) {\n    display: none !important;\n  }\n}\n\n.tooltip .tooltipContent {\n  width: 280px;\n  text-align: center;\n}\n\n.sberIcon {\n  width: 15px !important;\n  height: 15px !important;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mail": `src-containers-Profile-Emails-styles--mail--_DTu1`,
	"twoFactorAuthn": `src-containers-Profile-Emails-styles--twoFactorAuthn--oL0VY`,
	"twoFactorAuthnContent": `src-containers-Profile-Emails-styles--twoFactorAuthnContent--uwNUW`,
	"additional": `src-containers-Profile-Emails-styles--additional--A48R4`,
	"tooltip": `src-containers-Profile-Emails-styles--tooltip--p4Acb`,
	"tooltipContent": `src-containers-Profile-Emails-styles--tooltipContent--tQrXm`,
	"sberIcon": `src-containers-Profile-Emails-styles--sberIcon--F4yaH`,
	"row": `src-containers-Profile-Emails-styles--row--W8wVS`
};
module.exports = ___CSS_LOADER_EXPORT___;
